var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=CheckboxFilled, colour=Primary, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_box",
    d: "M10.9629 17.6L20.3629 8.2L18.4962 6.33333L10.9629 13.8667L7.16285 10.0667L5.29619 11.9333L10.9629 17.6ZM3.49619 24C2.76285 24 2.13508 23.7389 1.61285 23.2167C1.09063 22.6944 0.829521 22.0667 0.829521 21.3333V2.66667C0.829521 1.93333 1.09063 1.30556 1.61285 0.783333C2.13508 0.261111 2.76285 0 3.49619 0H22.1629C22.8962 0 23.524 0.261111 24.0462 0.783333C24.5684 1.30556 24.8295 1.93333 24.8295 2.66667V21.3333C24.8295 22.0667 24.5684 22.6944 24.0462 23.2167C23.524 23.7389 22.8962 24 22.1629 24H3.49619Z",
    fill: "#0595FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/CheckboxFilled.30b37549d4359c770a6b351865ff39be.svg";
export { ForwardRef as ReactComponent };